import {WOW} from "wowjs"

export function wowInit() {
    WOW.prototype.resetAnimation = function(event) {
        // var target;
        // if (event.type.toLowerCase().indexOf('animationend') >= 0) {
        //     target = event.target || event.srcElement;
        //     target.setAttribute("class", target.getAttribute("class").replace(this.config.animateClass).trim());
        //     return target.className
        // }
    };

    var wow = new WOW(
        {
            boxClass: 'wow',      // animated element css class (default is wow)
            offset: 100,
            mobile: true,       // trigger animations on mobile devices (default is true)
            live: false,
            duration: 2
        }
    );
    wow.init();
}